export enum NavLinkType {
  NavLinkList = "navLinkList",
  NavLinkPanel = "navLinkPanel",
  NavGroupHeading = "navGroupHeading",
  GeneralLink = "generalLink",
}

export interface ContentType {
  uid: string;
  component: string;
}

export const isLinkList = (link: { component?: string }) =>
  link?.component === NavLinkType.NavLinkList;
